export const DOCUMENTS_ACCESS_ROLES: string[] = ['access-control-admin'];

// Mi Portal shell root. The shell owns the guard that sends an unauthenticated visitor to the SSO
// login, so exiting to login means navigating to the root.
export const PORTAL_ROOT_PATH = '/';

// Version of the shell's `globalThis.__MIPORTAL_SESSION__` contract this MFE speaks. A host on a
// different version means the surface changed, so we degrade to our own exit instead of calling it.
export const SESSION_BRIDGE_VERSION = 1;
